import React from 'react';
import { useParams } from 'react-router-dom';
import PageTemplate from '../../components/template/PageTemplate';
import { SEARCH_DICTIONARY_PAGE_NAME } from '../../constants/service/app/searchDictionaryConstants';
import { SearchDictionaryRuleContainer } from '../../containers/search/SearchDictionaryRuleContainer';

/** 동의어 규칙 등록 · 상세 페이지 (AMZUWEB-694) */
const SearchDictionaryRule = (): React.JSX.Element => {
  const { id } = useParams<{ id: string }>();
  return (
    <PageTemplate pageName={id ? SEARCH_DICTIONARY_PAGE_NAME.RULE_DETAIL : SEARCH_DICTIONARY_PAGE_NAME.RULE_CREATE}>
      <SearchDictionaryRuleContainer />
    </PageTemplate>
  );
};

export default SearchDictionaryRule;
